import { useEffect, useState } from "react"

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */
export const useIsOnline = () => {
    const [isOnline, setIsOnline] = useState<boolean>(true)

    useEffect(() => {
        window.addEventListener("online", goOnline)
        window.addEventListener("offline", goOffline)

        return () => {
            window.removeEventListener("online", goOnline)
            window.removeEventListener("offline", goOffline)
        }
    }, [])

    const goOnline = () => {
        setIsOnline(true)
    }

    const goOffline = () => {
        setIsOnline(false)
    }

    return isOnline
}
